var ConversationIDSerialiser = require('conversation/conversation-id-serialiser');
var Codec = require('io/codec');

var serialiser = {
    read : function(input) {
    },
    write : function(output, request) {
        if (request.properties) {
            Codec.writeInt32(output, 0);
            Codec.writeCollection(output, request.properties, Codec.writeString);
        } else {
            Codec.writeInt32(output, 1);
        }

        ConversationIDSerialiser.write(output, request.cid);
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/set-session-properties-listener-serialiser.js
// module id = 1043
// module chunks = 1